
const STORAGE_KEY = "alert-item-prefix:"

export default {
  methods: {
    getStoredAlertItem() {
      const stringifiedItem = sessionStorage.getItem(`${STORAGE_KEY}${this.alertKey}`)
      return stringifiedItem && JSON.parse(stringifiedItem)
    },
    saveForShowingOnTableLater(key, item) {
      sessionStorage.setItem(`${STORAGE_KEY}${key}`, JSON.stringify(item))
    },
    clearAlert(key) {
      sessionStorage.setItem(`${STORAGE_KEY}${key}`, "")
    },
  },
}
